import React,{ useEffect,useRef} from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Required = ()=>{
    const sec1 = useRef(null);
    useEffect(() => {
        gsap.set(sec1.current, { opacity: 0, y: 100 });
        gsap.to(sec1.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec1.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    },[]);


    return(
        <section className="w-full bg-custom-gradient text-white font-guton mb-10">
            <div ref={sec1} className="flex flex-col md:flex-row w-90 mx-auto py-20 max-w-[1440px]">
                <div className="flex flex-col w-95  md:w-35 mr-20 xl:mr-28">
                    <h2 className="text-37 leading-28 xl:text-64 leading-36 xl:leading-55 font-semibold w-55">What's Required?</h2>
                    <p className="text-18 xl:text-20 leading-14 xl:leading-21 font-medium mt-4 mb-8 md:my-8 xl:tracking-[-0.6px] w-full xl:w-90">The papers needed are pretty clear and simple. <span className="font-semibold">We ease the process for you all the way till you relocate!</span></p>
                </div>
                <div className="flex w-full md:w-65 xl:w-70">
                <div className="flex flex-col w-[100px] md:w-[150px] space-y-16 xl:space-y-20 mr-12 xl:mr-28">
                    <h2 className="text-18 xl:text-32 leading-18 xl:leading-32 font-semibold">Academic Documentation</h2>
                    <h2 className="text-18 xl:text-32 leading-18 xl:leading-32 font-semibold">Visa Documents</h2>
                    <h2 className="text-18 xl:text-32 leading-18 xl:leading-32 font-semibold">Health & Travel</h2>
                    <h2 className="text-18 xl:text-32 leading-18 xl:leading-32 font-semibold">Financial Proof</h2>
                </div>
                <div className="flex flex-col w-70 xl:w-1/2 xl:ml-20">
                    <p className="text-14 xl:text-24 leading-16 mb-3 xl:leading-24 tracking-[-0.6px]">Certificate of Recognition of High School Diploma & Original Diploma</p>
                    <p className="text-14 xl:text-24 leading-16 mb-5 md:mb-7 xl:leading-24 tracking-[-0.6px]">University Admission Letter (Acceptance Letter)</p>
                    <p className="text-14 xl:text-24 leading-16 mb-5 xl:leading-24 tracking-[-0.6px]">Schengen Visa</p>
                    <p className="text-14 xl:text-24 leading-16 mb-10 xl:leading-24 tracking-[-0.6px]">Valid Passport</p>
                    <p className="text-14 xl:text-24 leading-16 mb-5 xl:leading-24 tracking-[-0.6px]">Health Insurance</p>
                    <p className="text-14 xl:text-24 leading-16 mb-[45px] md:mb-[50px] xl:leading-24 tracking-[-0.6px]">Flight Tickets</p>
                    <p className="text-14 xl:text-24 leading-16 mb-5 xl:leading-24 tracking-[-0.6px]">Bank Statement</p>
                    <p className="text-14 xl:text-24 leading-16 mb-5 xl:leading-24 tracking-[-0.6px]">Financial Support Letter</p>
                    <p className="text-14 xl:text-24 leading-16 mb-5 xl:leading-24 tracking-[-0.6px]">HR Letter</p>
                </div>
                </div>
            </div>
        </section>
    )
}

export default Required;